import React from 'react';
export default function FilterButton(props) {
    return <button type="button" className={'btn mr-2 ' + (props.isSelected ? " btn-success" : " btn-outline-success")} onClick={props.onClick} style={{ fontSize: 12 }}>
        {props.value}
    </button>
}
